export default "__VITE_ASSET__DfM92kdD__"